import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SearchBarComponent} from './search-bar/search-bar.component';
import {NavBarComponent} from './nav-bar/nav-bar.component';
import {TrackingResultComponent} from './tracking-result/tracking-result.component';
import {SummaryComponent} from './tracking-result/summary/summary.component';
import {ContainerComponent} from './tracking-result/container/container.component';
import {TimelineComponent} from './tracking-result/timeline/timeline.component';
import {HomeComponent} from './home/home.component';
import {SettingsComponent} from './settings/settings.component';
import {provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {FormsModule} from "@angular/forms";
import {NgProgressModule} from "ngx-progressbar";
import {NgProgressHttpModule} from "ngx-progressbar/http";
import {CommonModule} from "@angular/common";

@NgModule({
    declarations: [
        AppComponent,
        SearchBarComponent,
        NavBarComponent,
        TrackingResultComponent,
        SummaryComponent,
        ContainerComponent,
        TimelineComponent,
        HomeComponent,
        SettingsComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        CommonModule,
        AppRoutingModule,
        FormsModule,
        NgProgressModule,
        NgProgressHttpModule,
    ],
    providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class AppModule {
}
